import React, { FC, useState } from 'react';
import { Outbound } from 'ts/flight/interfaces/FlightSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCartFlatbedSuitcase,
  faPersonWalkingLuggage,
  faSuitcaseRolling,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import TicketBaggagePopup from './TicketBaggagePopup';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface TicketRouteBaggageProps {
  outbond: Outbound;
  choose: () => void;
}

const TicketRouteBaggage: FC<TicketRouteBaggageProps> = ({ outbond, ...props }) => {
  const [t] = useTranslation();
  const [showDetails, setShowDetails] = useState(false);

  const isRedHandbag =
    !outbond.listOfFlyBaggagePrice ||
    !outbond.listOfFlyBaggagePrice?.[0] ||
    outbond.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag === 0;
  const isRedTrolley =
    !outbond.listOfFlyBaggagePrice ||
    !outbond.listOfFlyBaggagePrice?.[0] ||
    outbond.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley === 0;
  const isGreenTotal =
    outbond.listOfFlyBaggagePrice &&
    (outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight > 0 ||
      outbond.listOfFlyBaggagePrice?.[0]?.pieces > 0);

  return (
    <div
      className="ticket-baggage"
      onMouseEnter={() => setShowDetails(true)}
      onMouseLeave={() => setShowDetails(false)}
    >
      {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag !== -1 && (
        <div className="mb-5">
          <FontAwesomeIcon
            icon={faSuitcaseRolling as any}
            className={isRedHandbag ? 'color-danger' : 'text-success'}
          />
          {isRedHandbag ? (
            <span className="color-danger">{t('flight.handbag_excluded')}</span>
          ) : (
            <span className="text-success">{t('flight.handbag_included')}</span>
          )}
        </div>
      )}

      {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley !== -1 && (
        <div className="mb-5">
          <FontAwesomeIcon
            icon={faPersonWalkingLuggage as any}
            className={isRedTrolley ? 'color-danger' : 'text-success'}
          />
          {isRedTrolley ? (
            <span className="color-danger">{t('flight.trolley_excluded')}</span>
          ) : (
            <span className="text-success">{t('flight.trolley_included')}</span>
          )}
        </div>
      )}

      {outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight !== -1 && (
        <div>
          <FontAwesomeIcon
            icon={faCartFlatbedSuitcase as any}
            className={isGreenTotal ? 'text-success' : 'color-danger'}
          />
          {isGreenTotal ? (
            <span className="text-success">{t('flight.bag_included')}</span>
          ) : (
            <span className="color-danger">{t('flight.bag_excluded')}</span>
          )}
        </div>
      )}
      {showDetails && <TicketBaggagePopup outbond={outbond as any} />}
    </div>
  );
};

export default withErrorBoundary(TicketRouteBaggage, 'TicketRouteBaggage');
